/* eslint-disable max-len */
import {
  TranslationBaseCardMessages,
  TranslationCertificateMessages,
  TranslationClientMessages,
  TranslationConcretingApprovalMessages,
  TranslationConcretingMessages,
  TranslationConcretingRequestMessages,
  TranslationContractMessages,
  TranslationCustomerMessages,
  TranslationDataTableMessages,
  TranslationExpiredSessionMessages,
  TranslationForgotPasswordMessages,
  TranslationGlobalMessages,
  TranslationInvoiceMessages,
  TranslationLoginMessages,
  TranslationMuiMessages,
  TranslationPermissionMessages,
  TranslationSettingMessages,
  TranslationSignUpMessages,
  TranslationYupMessages,
  TranslationResendConfirmationEmailMessages,
  TranslationDeleteAccountMessages,
  TranslationChangePasswordMessages,
  TranslationAlertMessages
} from "./interfaces";

interface TranslationData
  extends TranslationYupMessages,
    TranslationMuiMessages,
    TranslationCustomerMessages,
    TranslationGlobalMessages,
    TranslationDataTableMessages,
    TranslationExpiredSessionMessages,
    TranslationLoginMessages,
    TranslationSignUpMessages,
    TranslationBaseCardMessages,
    TranslationContractMessages,
    TranslationPermissionMessages,
    TranslationConcretingRequestMessages,
    TranslationConcretingApprovalMessages,
    TranslationSettingMessages,
    TranslationForgotPasswordMessages,
    TranslationResendConfirmationEmailMessages,
    TranslationDeleteAccountMessages,
    TranslationChangePasswordMessages,
    TranslationAlertMessages {
}

export interface LanguageData {
  translation: TranslationData;
}

export type TLanguages = "pt-BR" | "en-US" | "es";

interface ILanguage {
  language: TLanguages;
  description: string;
}

export const languages: ILanguage[] = [
  {
    language: "en-US",
    description: "English"
  },
  {
    language: "pt-BR",
    description: "Português"
  },
  {
    language: "es",
    description: "Español"
  }
];

/**
 *
 * @param language
 * @param fileName
 * @returns
 */
const getMessages = (language: TLanguages, fileName: string) => {
  const data = require(`./${language}/${fileName}.ts`);

  return data.messages;
};

export function getLanguageData(language: TLanguages) {
  const customerMessages = getMessages(
    language,
    "customerMessages"
  ) as TranslationCustomerMessages;
  const yupErrorsMessages = getMessages(
    language,
    "yupMessages"
  ) as TranslationYupMessages;
  const expiredSessionMessages = getMessages(
    language,
    "expiredSessionMessages"
  ) as TranslationExpiredSessionMessages;
  const muiMessages = getMessages(
    language,
    "muiMessages"
  ) as TranslationMuiMessages;
  const dataTableMessages = getMessages(
    language,
    "dataTableMessages"
  ) as TranslationDataTableMessages;
  const loginMessages = getMessages(
    language,
    "loginMessages"
  ) as TranslationLoginMessages;
  const signUpMessages = getMessages(
    language,
    "signUpMessages"
  ) as TranslationSignUpMessages;
  const globalMessages = getMessages(
    language,
    "globalMessages"
  ) as TranslationGlobalMessages;
  const certificateMessages = getMessages(
    language,
    "certificateMessages"
  ) as TranslationCertificateMessages;
  const clientMessages = getMessages(
    language,
    "clientMessages"
  ) as TranslationClientMessages;
  const concretingMessages = getMessages(
    language,
    "concretingMessages"
  ) as TranslationConcretingMessages;
  const contractMessages = getMessages(
    language,
    "contractMessages"
  ) as TranslationContractMessages;
  const invoiceMessages = getMessages(
    language,
    "invoiceMessages"
  ) as TranslationInvoiceMessages;
  const baseCardMessages = getMessages(
    language,
    "baseCardMessages"
  ) as TranslationBaseCardMessages;
  const permissionMessages = getMessages(
    language,
    "permissionMessages"
  ) as TranslationPermissionMessages;
  const concretingRequestMessages = getMessages(
    language,
    "concretingRequestMessages"
  ) as TranslationConcretingRequestMessages;
  const concretingApprovalMessages = getMessages(
    language,
    "concretingApprovalMessages"
  ) as TranslationConcretingApprovalMessages;
  const settingMessages = getMessages(
    language,
    "settingMessages"
  ) as TranslationSettingMessages;
  const forgotPasswordMessages = getMessages(
    language,
    "forgotPasswordMessages"
  ) as TranslationForgotPasswordMessages;
  const resendConfirmationEmailMessages = getMessages(
    language,
    "resendConfirmationEmailMessages"
  ) as TranslationResendConfirmationEmailMessages;
  const deleteAccountMessages = getMessages(
    language,
    "deleteAccountMessages"
  ) as TranslationDeleteAccountMessages;
  const changePasswordMessages = getMessages(
    language,
    "changePasswordMessages"
  ) as TranslationChangePasswordMessages;
  const alertMessages = getMessages(
    language,
    "alertMessages"
  ) as TranslationAlertMessages;

  const languageData: LanguageData = {
    translation: {
      ...muiMessages,
      ...customerMessages,
      ...globalMessages,
      ...yupErrorsMessages,
      ...dataTableMessages,
      ...expiredSessionMessages,
      ...loginMessages,
      ...signUpMessages,
      ...certificateMessages,
      ...clientMessages,
      ...concretingMessages,
      ...contractMessages,
      ...invoiceMessages,
      ...baseCardMessages,
      ...permissionMessages,
      ...concretingRequestMessages,
      ...concretingApprovalMessages,
      ...settingMessages,
      ...forgotPasswordMessages,
      ...resendConfirmationEmailMessages,
      ...deleteAccountMessages,
      ...changePasswordMessages,
      ...alertMessages
    }
  };

  return languageData;
}
